import src from "IMAGE";
export default { src, width: 423, height: 424, blurWidth: 0, blurHeight: 0};
